import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/Layout.vue'
import { hasPermission, hasAnyPermission } from '@/utils/permission'

Vue.use(VueRouter)

// 计算第一个有权限的路径
function getFirstAccessiblePath() {
  const paths = [
    { path: '/wallpaper', perm: 'wallpaper:view' },
    { path: '/crawler', perm: 'wallpaper:view' },
    { path: '/review', perm: 'submission:view' },
    { path: '/users', perm: 'user:view' },
    { path: '/category', perm: 'category:view' },
    { path: '/tag', perm: 'tag:view' },
    { path: '/announcement', perm: 'announcement:view' },
    { path: '/feedback', perm: 'feedback:view' },
    { path: '/report', perm: 'report:view' },
    { path: '/system', perm: 'setting:view' },
    { path: '/settings', perm: 'manager:view' },
    { path: '/operationLog', perm: 'log:view' }
  ]
  for (const item of paths) {
    if (hasPermission(item.perm)) {
      return item.path
    }
  }
  return '/no-permission'
}

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/no-permission',
    name: 'NoPermission',
    component: () => import('@/views/NoPermission.vue'),
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { requiresAuth: true, permissions: ['wallpaper:view', 'submission:view', 'user:view', 'setting:view', 'manager:view'] }
      },
      {
        path: 'wallpaper',
        name: 'Wallpaper',
        component: () => import('@/views/wallpaper/index.vue'),
        meta: { requiresAuth: true, permissions: ['wallpaper:view'] }
      },
      {
        path: 'crawler',
        name: 'Crawler',
        component: () => import('@/views/crawler/index.vue'),
        meta: { requiresAuth: true, permissions: ['wallpaper:view'] }
      },
      {
        path: 'review',
        name: 'Review',
        component: () => import('@/views/review/index.vue'),
        meta: { requiresAuth: true, permissions: ['submission:view'] }
      },
      {
        path: 'users',
        name: 'Users',
        component: () => import('@/views/users/index.vue'),
        meta: { requiresAuth: true, permissions: ['user:view'] }
      },
      {
        path: 'advert',
        name: 'Advert',
        component: () => import('@/views/advert/index.vue'),
        meta: { requiresAuth: true, permissions: ['wallpaper:view', 'announcement:view'] }
      },
      {
        path: 'category',
        name: 'Category',
        component: () => import('@/views/category/index.vue'),
        meta: { requiresAuth: true, permissions: ['category:view'] }
      },
      {
        path: 'tag',
        name: 'Tag',
        component: () => import('@/views/tag/index.vue'),
        meta: { requiresAuth: true, permissions: ['tag:view'] }
      },
      {
        path: 'quote',
        name: 'Quote',
        component: () => import('@/views/quote/index.vue'),
        meta: { requiresAuth: true, permissions: ['quote:view'] }
      },
      {
        path: 'settings',
        name: 'Settings',
        component: () => import('@/views/settings/index.vue'),
        meta: { requiresAuth: true, permissions: ['manager:view', 'setting:view'] }
      },
      {
        path: 'system',
        name: 'System',
        component: () => import('@/views/system/index.vue'),
        meta: { requiresAuth: true, permissions: ['setting:view'] }
      },
      {
        path: 'operationLog',
        name: 'OperationLog',
        component: () => import('@/views/operationLog/index.vue'),
        meta: { requiresAuth: true, permissions: ['log:view'] }
      },
      {
        path: 'announcement',
        name: 'Announcement',
        component: () => import('@/views/announcement/index.vue'),
        meta: { requiresAuth: true, permissions: ['announcement:view'] }
      },
      {
        path: 'feedback',
        name: 'Feedback',
        component: () => import('@/views/feedback/index.vue'),
        meta: { requiresAuth: true, permissions: ['feedback:view'] }
      },
      {
        path: 'report',
        name: 'Report',
        component: () => import('@/views/report/index.vue'),
        meta: { requiresAuth: true, permissions: ['report:view'] }
      },
      {
        path: 'notification',
        name: 'Notification',
        component: () => import('@/views/notification/index.vue'),
        meta: { requiresAuth: true, permissions: ['manager:view', 'setting:view'] }
      },
      {
        path: 'help',
        name: 'Help',
        component: () => import('@/views/help/index.vue'),
        meta: { requiresAuth: true }
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('@/views/profile/index.vue'),
        meta: { requiresAuth: true }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (to.meta.requiresAuth && !token) {
    next('/login')
  } else if (to.path === '/login' && token) {
    // 登录后跳转到第一个有权限的页面
    next(getFirstAccessiblePath())
  } else if (to.meta.permissions && to.meta.permissions.length > 0) {
    const has = to.meta.permissions.some(p => hasPermission(p))
    if (!has) {
      next({ path: '/no-permission', replace: true })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
